import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { lightThemeObject } from "../../styleguide";
var StyledDivider = styled.hr.withConfig({
  displayName: "Divider__StyledDivider",
  componentId: "sc-t5wtsv-0"
})(["width:100%;height:1px;border:none;margin:0;background-color:var(--bui-divider,", ");"], lightThemeObject['--bui-divider']);
export var Divider = function Divider(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(StyledDivider, {
    className: className,
    style: style
  });
};
Divider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the default styles.
   */
  style: PropTypes.object,
  className: PropTypes.string
} : {};
export default Divider;
//# sourceMappingURL=Divider.js.map